let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("khl2I")).then(() => parcelRequire('4mDTB'));